<template>
  <div class="text-center mb-6">
    <p class="font-bold text-lg text-grey-2 mb-9 mt-6">
      {{ $t('wording.add_sin.title') }} 
    </p>
    <p class="text-sm text-grey-2 text-opacity-60">
      {{ $t('wording.add_sin.description') }}
    </p>
    <Form class="form" ref="form" v-slot="{ errors, meta }">
      <GeneralInput
        v-model:data="sin"
        type="number"
        name="sin"
        :label="$t('wording.add_sin.input')"
        rules="required|exactLength:9"
        :error="errors.names"
      />
      
      <GpButton
        :disabled="!(isDirty || meta.dirty) || !meta.valid"
        @click="next()"
        class="ml-auto"
      >
        {{ $t('wording.add_sin.ok') }}
      </GpButton>
    </Form>
  </div>
</template>
<script>
import { ref } from 'vue'
import GpButton from '@/components/general/GpButton.vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import GeneralInput from '@/components/general/Input.vue'
import { Form } from 'vee-validate'
import useProfile from '@/mixins/useProfile.js'


export default {
  components: {
    GeneralInput,
    GpButton,
    Form
  },
  props: {
    method: String
  },
  setup() {

    const { updateProfile } = useProfile()
    const form = ref(null)
    const router = useRouter()
    const store = useStore()
    const i18n = useI18n()
    const sin = ref('')
    
    function next(){
      updateProfile({sin: sin.value})
        .then(() => {
          form.value.resetForm()
          const popup = {
            title: i18n.t('settings.personal_details.success_popup.title'),
            align: 'center',
            side: false,
            iconBg: 'bg-green-5',
            icon: '/img/done_step.svg',
            primaryButton: i18n.t('settings.personal_details.success_popup.btn'),
            primaryLink: window.location.reload()
          }
          store.dispatch('setPopup', popup)
          store.dispatch('fetchProfile')
        })
    }
    return {
      next,
      form,
      sin
    }
  }
}
</script>
